import * as React from 'react';

import { Image } from './careers-values-stripes.styles';

export const StripesView = ({ imageSrc }) => <Image src={imageSrc} alt="" />;
